import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ALLOWED_LANGUAGES } from '../../../shared/constants';

@Component({
  selector: 'ds-lib-language-picker',
  templateUrl: './ds-lib-language-picker.component.html',
  styleUrls: ['./ds-lib-language-picker.component.scss'],
})
export class DsLibLanguagePickerComponent {
  /**
   * The current language. Double-way binding.
   */
  @Input() language = '';

  /**
   * An EventEmitter fired language is changed
   */
  @Output() languageChange = new EventEmitter();

  /**
   * The languages array
   */
  languages = ALLOWED_LANGUAGES;

  /**
   * Emit the selected language.
   */
  onLangChange() {
    this.languageChange.emit(this.language);
  }
}
